var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_33_4945",
    maskUnits: "userSpaceOnUse",
    x: 6.5,
    y: 8.5,
    width: 11,
    height: 7
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.5,
    y: 8.5,
    width: 11,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6788 9.63273L7.63286 13.7165C7.45571 13.8956 7.45571 14.186 7.63286 14.3656C7.81 14.5448 8.09773 14.5448 8.27487 14.3656L11.9998 10.6058L15.7247 14.3652C15.9018 14.5443 16.1896 14.5443 16.3671 14.3652C16.5443 14.186 16.5443 13.8952 16.3671 13.716L12.3212 9.63227C12.1459 9.45583 11.8537 9.45583 11.6788 9.63273Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6788 9.63273L7.63286 13.7165C7.45571 13.8956 7.45571 14.186 7.63286 14.3656C7.81 14.5448 8.09773 14.5448 8.27487 14.3656L11.9998 10.6058L15.7247 14.3652C15.9018 14.5443 16.1896 14.5443 16.3671 14.3652C16.5443 14.186 16.5443 13.8952 16.3671 13.716L12.3212 9.63227C12.1459 9.45583 11.8537 9.45583 11.6788 9.63273Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6788 9.63273L7.63286 13.7165C7.45571 13.8956 7.45571 14.186 7.63286 14.3656C7.81 14.5448 8.09773 14.5448 8.27487 14.3656L11.9998 10.6058L15.7247 14.3652C15.9018 14.5443 16.1896 14.5443 16.3671 14.3652C16.5443 14.186 16.5443 13.8952 16.3671 13.716L12.3212 9.63227C12.1459 9.45583 11.8537 9.45583 11.6788 9.63273Z",
    mask: "url(#path-1-outside-1_33_4945)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevronUp.63c538ce91590d1ea3f5db3bf5bdcb49.svg";
export { ForwardRef as ReactComponent };